import TimeSelect from './src/time-select2.mjs';
export { timeSelectProps } from './src/time-select.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTimeSelect = withInstall(TimeSelect);

export { ElTimeSelect, ElTimeSelect as default };
//# sourceMappingURL=index.mjs.map
